import { useEffect, useRef } from 'react';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { toast } from '@/hooks/use-toast';
import { useTranslation } from 'react-i18next';

export function ConnectionRestoredToast() {
  const { isOnline } = useNetworkStatus();
  const { t } = useTranslation();
  const wasOfflineRef = useRef(false);

  useEffect(() => {
    if (!isOnline) {
      wasOfflineRef.current = true;
    }
    
    if (isOnline && wasOfflineRef.current) {
      toast({
        title: t('errors.connectionRestored'),
        description: t('errors.dataRefreshing'),
      });
      wasOfflineRef.current = false;
    }
  }, [isOnline, t]);

  return null;
}
